import { QuoteBinding, QuoteBindingStatus } from '@models/quoteBinding';

/** Helper function to format some of the info from the received quote binding information */
export const formatCurrentQuoteBindingInformation = ({
  currentQuoteId,
  latestPolledQuoteBindings,
  quoteBindings,
}: {
  /** The quote id of the current quote detail page */
  currentQuoteId: string;
  /** Array of all the quote bindings for quotes and any related multi policy quotes */
  quoteBindings: Partial<QuoteBinding>[];
  /** Array of all the latest polled quote bindings for quotes and any related multi policy quotes */
  latestPolledQuoteBindings: QuoteBinding[];
}) => {
  const quotes = (
    latestPolledQuoteBindings && latestPolledQuoteBindings?.length ? latestPolledQuoteBindings : quoteBindings
  )?.filter((q) => !!q.id);

  const latestPolledOrSearchedIsActive = quotes?.some(
    (lb) => lb?.status === QuoteBindingStatus.Pending || lb?.status === QuoteBindingStatus.InProgress,
  );

  const latestPolledOrSearchedCompleted =
    quotes.length > 0 &&
    quotes?.every((lb) => lb?.status !== QuoteBindingStatus.Pending && lb?.status !== QuoteBindingStatus.InProgress);

  const currentQuoteLatestBindingStatus =
    quotes.length > 0 && quotes?.find((q) => q.quoteId === currentQuoteId)?.status;

  return { currentQuoteLatestBindingStatus, latestPolledOrSearchedIsActive, latestPolledOrSearchedCompleted };
};
